module.exports = __webpack_public_path__ + "static/media/product-manufacturing-desktop-header.96823c37.jpg";